import React from "react";
import "./gemeinde.styles.scss";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { selectErntehelfer } from "../../redux/gemeinde/gemeinde.selector";
import {
  makeStyles,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableSortLabel,
  Table,
  Typography,
} from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  root: {
    margin: "10px",
    [theme.breakpoints.up("lg")]: {
      maxWidth: "1000px",
    },
  },
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: "displayName", numeric: false, label: "Name", sortable: true },
  {
    id: "email",
    numeric: false,
    label: "E-Mail-Adresse",
    sortable: true,
  },
  { id: "isSaemann", numeric: false, label: "Rolle", sortable: false },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.sortable ? (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                <Typography variant="h6">{headCell.label}</Typography>
              </TableSortLabel>
            ) : (
              <Typography variant="h6">{headCell.label}</Typography>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
const GemeindeMitglieder = ({ erntehelfer }) => {
  const classes = useStyles();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("displayName");
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  return (
    <div className={classes.root}>
      <TableContainer>
        <Table>
          <EnhancedTableHead
            classes={classes}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
          />
          <TableBody>
            {stableSort(erntehelfer, getComparator(order, orderBy)).map(
              (mitglied) => (
                <TableRow key={mitglied.id}>
                  <TableCell>{mitglied.displayName}</TableCell>
                  <TableCell>{mitglied.email}</TableCell>
                  <TableCell>
                    {mitglied.isSaemann ? "Sämann" : "Erntehelfer"}
                  </TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
const mapStateToProps = createStructuredSelector({
  erntehelfer: selectErntehelfer,
});

export default connect(mapStateToProps)(GemeindeMitglieder);
